import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import ET3Div from "../../et3-div";
import Et3Margin from "../../et3-ui/ET3Margin";

const PopUpCloseButton = withLiteObserverAndTheme<{ onClick: () => void }>(
  (props) => {
    const { onClick, theme } = props;
    const { colors, getFontSize } = theme;

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={55}
        height={30}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <FontAwesomeIcon
          icon={faTimes}
          className="clickable"
          size="lg"
          onClick={() => onClick()}
          style={{
            color: colors.all.bondiBlue,
            fontSize: getFontSize(50)
          }}
        />
        <Et3Margin right={10} left={10} top={0} bottom={0} />
      </ET3Div>
    );
  }
);

export default PopUpCloseButton;
